import ToolTip from "../ToolTip";
import ExternalLink from "../ExternalLink/ExternalLink";
import * as React from "react";
import { Link } from "react-router-dom";
import styles = require("./style.less");
import { repository } from "clientInstance";
import CloseButton from "components/Button/CloseButton";

interface EAPBarState {
    version: string;
    isEarlyAccessProgram: boolean;
    isHidden: boolean;
}

interface EAPProps {
    onCloseClicked(): void;
}

export default class EAPBar extends React.Component<EAPProps, EAPBarState> {

    constructor(props: EAPProps) {
        super(props);

        this.state = {
            isEarlyAccessProgram: false,
            isHidden: false,
            version: ""
        };
    }

    componentDidMount() {
        const root = repository.getRootDocument();
        const isEarlyAccessProgram = root.IsEarlyAccessProgram || false;
        const version = root.Version;

        this.setState({
            isEarlyAccessProgram,
            version
        });
    }

    onClose() {
        this.setState({isHidden: true});
        this.props.onCloseClicked();
    }

    render() {
        if (!this.state.isEarlyAccessProgram || this.state.isHidden) {
            return null;
        }

        return <div className={styles.eapBanner}>
            <ToolTip content="Due to the unstable nature of EAP releases we do not recommend using them in production, or upgrading them to/from a production instance">
                <ExternalLink href="WhatIsEAP" showIcon={false}>
                    EAP Release - v{this.state.version}
                </ExternalLink>
            </ToolTip>
            <div className={styles.closeEAPBanner}>
                <CloseButton onClose={() => this.onClose()} />
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Navbar/EAPBar.tsx